module.exports = __webpack_public_path__ + "img/bryan-scaled.7506da64.jpg";